export const option = {
    width: 500,
    tooltip: {
        show: true,
        trigger: "axis",
        backgroundColor: "#9A48E9",
        formatter: function(params) {
            const param = params[0];
            return `Current Status:<br/>Current Membership Price: ${param.value} COCOS<br/>Memberships Sold: ${+param.axisValue + 1} ~ ${+param.axisValue + 100}`
        },
        textStyle: {
            color: "#FFF",
            fontSize: 12
        },
        borderWidth: 0
    },
    textStyle: {
        color: "#74A0FF",
        fontSize: 14
    },
    backgroundColor: 'transparent',
    xAxis: {
        type: 'category',
        axisLine: {
          show: false
        },
        axisTick: {
            show: false
        },
        data: [
            0,
            100,
            200,
            300,
            400,
            500,
            600,
            700,
            800,
            900,
            1000,
            1100,
            1200,
            1300,
            1400,
            1500,
            1600,
            1700,
            1800,
            1900,
            2000,
            2100,
            2200,
            2300,
            2400,
            2500,
            2600,
            2700,
            2800,
            2900,
            3000,
            3100,
            3200,
            3300,
            3400,
            3500,
            3600,
            3700,
            3800,
            3900,
            4000,
            4100,
            4200,
            4300,
            4400,
            4500,
            4600,
            4700,
            4800,
            4900
        ]
    },
    yAxis: {
        type: 'value',
        splitLine: {
            lineStyle: {
                color: ['rgb(26,82,195)']
            }
        },
    },
    series: [
        {
            showSymbol: false,
            lineStyle: {
                color: "#329CFA"
            },
            markPoint: {
                showSymbol: true,
                data: [{value: 0, xAxis: 0, yAxis: 0}],
                label: {show: true, fontSize: 12},
                animation: false,
                itemStyle: {
                    color:"#9A48E9",
                }
            },
            data: [
                10,
                12,
                14,
                16,
                18,
                20,
                22,
                24,
                26,
                28,
                30,
                32,
                34,
                36,
                38,
                40,
                42,
                44,
                46,
                48,
                50,
                52,
                54,
                56,
                58,
                60,
                62,
                64,
                66,
                68,
                70,
                72,
                74,
                76,
                78,
                80,
                82,
                84,
                86,
                88,
                90,
                92,
                94,
                96,
                98,
                100,
                102,
                104,
                106,
                108
            ],
            type: 'line'
        }
    ]
}